// extracted by mini-css-extract-plugin
module.exports = {"elementContainer":"CustomTooltip_elementContainer__3yBdS","tooltipBody":"CustomTooltip_tooltipBody__PhaTF"};